import { Button } from "reactstrap";
import useFetchNotifications from "../../api/api-hooks/notifications/useFetchNotifications";
import {
  InitialNotificationQuery,
  NotificationsList,
} from "../cloud/Notifications/NotificationsPage";
import WidgetWrapper from "./WidgetWrapper";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../atoms/GlobalAtoms";

const NotificationQuery = InitialNotificationQuery();

export default function NotificationsWidget() {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);
  const { notifications, loading } = useFetchNotifications(
    NotificationQuery,
    false
  );
  const filteredNotifications = structuredClone(notifications).splice(0, 6);

  return (
    <WidgetWrapper
      title="Notifications"
      className="px-2"
      options={
        <Button
          size="sm"
          color="primary"
          outline
          onClick={() => navigate(`/clouds/${tenantID}/user/conversations`)}
        >
          View All
        </Button>
      }
    >
      <NotificationsList
        notifications={filteredNotifications}
        loading={loading}
        onSelectNotification={() => {}}
        maxWidth={550}
      />
    </WidgetWrapper>
  );
}
